/*<Buttons type={'primary'} onClick={()=>alert('ahí va')} cta={'test'}></Buttons>?*/
import './Buttons.css';
const Buttons = ({ type, onClick, cta }) => {
    const handleClick = () => {
        return onClick !== '' ? onClick() :null
    };
    return (
        <button className={`button button--${type}`} onClick={handleClick}>{cta}</button>    
    )
}

export default Buttons;